import { Service, ServiceCategory } from './types';

export const SERVICE_CATEGORIES: ServiceCategory[] = [
  {
    id: 'cleaning',
    slug: 'cleaning',
    name: 'Cleaning',
    description:
      'Schedule your recurring standard cleaning here, and keep your office healthy, spotless, and guest-ready with optional add-on services.',
    imageUrl: 'https://assets.codi.com/Services/Categories/Category_Cleaning_d48nqjDW7.png?updatedAt=1766101174940',
    imageUrlMobile:
      'https://assets.codi.com/Services/Categories/Mobile/Category_Cleaning_Lzl9nr-le.png?updatedAt=1766101439376',
    bannerUrl: 'https://assets.codi.com/Services/Cleaning/Category%20Banner_Hwnu8LJqj.png',
    bannerUrlMobile: 'https://assets.codi.com/Services/Cleaning/Cleaning%20Banner%20Mobile_QhBnseZY6.png'
  },
  {
    id: 'design',
    slug: 'design',
    name: 'Design & experience',
    description:
      'Transform your workspace with professional design services and enhance the office experience for your team.',
    imageUrl:
      'https://assets.codi.com/Services/Categories/Category_DesignExperience_ku6WlmI4h.png?updatedAt=1766101174922',
    imageUrlMobile:
      'https://assets.codi.com/Services/Categories/Mobile/Category_DesignExperience_ze9bKI1uJ.png?updatedAt=1766101439380',
    bannerUrl: 'https://assets.codi.com/Services/DesignExperience/Desktop/Category%20Banner_569abKZqf.png',
    bannerUrlMobile: 'https://assets.codi.com/Services/DesignExperience/Mobile/Category%20Banner_xCE-Cb_pI.png'
  },
  {
    id: 'it',
    slug: 'it',
    name: 'IT & A/V support',
    description: 'Technical support and audiovisual services to keep your office technology running smoothly.',
    imageUrl: 'https://assets.codi.com/Services/Categories/Category_ItAvSupport_PUm37SyCT.png?updatedAt=1766101174925',
    imageUrlMobile:
      'https://assets.codi.com/Services/Categories/Mobile/Category_ItAvSupport_kAR4-6KNR.png?updatedAt=1766101439558',
    bannerUrl:
      'https://assets.codi.com/Services/ItAvSupport/Desktop/Category%20Banner_ypZqqXEzLZ.png?updatedAt=1766172781032',
    bannerUrlMobile:
      'https://assets.codi.com/Services/ItAvSupport/Mobile/Category%20Banner_5fQEfcM2UX.png?updatedAt=1766172791104'
  },
  {
    id: 'maintenance',
    slug: 'maintenance',
    name: 'Maintenance',
    description: 'Keep your office in top condition with maintenance and repair services.',
    imageUrl: 'https://assets.codi.com/Services/Categories/Category_Maintenance_Nc1i-HGfof.png?updatedAt=1766101174914',
    imageUrlMobile:
      'https://assets.codi.com/Services/Categories/Mobile/Category_Maintenance_Dqz_vR4Ce.png?updatedAt=1766101439553',
    bannerUrl:
      'https://assets.codi.com/Services/Maintenance/Desktop/Category%20Banner_I6oBV5eBV_.png?updatedAt=1766173590341',
    bannerUrlMobile:
      'https://assets.codi.com/Services/Maintenance/Mobile/Category%20Banner_TY8x3TDwoL.png?updatedAt=1766173600969'
  },
  {
    id: 'catering-events',
    slug: 'catering-events',
    name: 'Pantry, beverages, & catering',
    description: 'Catering services, pantry restocking, and beverage solutions for your office.',
    imageUrl:
      'https://assets.codi.com/Services/Categories/Category_PantryBeveragesCatering_V-xFrDgDfz.png?updatedAt=1766101174950',
    imageUrlMobile:
      'https://assets.codi.com/Services/Categories/Mobile/Category_PantryBeveragesCatering_XFLJbrnrI.png?updatedAt=1766101439549',
    bannerUrl:
      'https://assets.codi.com/Services/PantryBeveragesCatering/Desktop/Category%20Banner_6dAh-DH8M.png?updatedAt=1766176219805',
    bannerUrlMobile:
      'https://assets.codi.com/Services/PantryBeveragesCatering/Mobile/Category%20Banner_nw3nCRFAKt.png?updatedAt=1766176232055'
  },
  {
    id: 'security-access',
    slug: 'security-access',
    name: 'Security & access',
    description: 'Security systems and access control solutions for your workspace.',
    imageUrl:
      'https://assets.codi.com/Services/Categories/Category_SecurityAccess_DQ7OrQzI1i.png?updatedAt=1766101174937',
    imageUrlMobile:
      'https://assets.codi.com/Services/Categories/Mobile/Category_SecurityAccess_fLnSxOoRxr.png?updatedAt=1766101439556',
    bannerUrl:
      'https://assets.codi.com/Services/SecurityAccess/Desktop/Category%20Banner_ngKSgrLkW.png?updatedAt=1766179606179',
    bannerUrlMobile:
      'https://assets.codi.com/Services/SecurityAccess/Mobile/Category%20Banner_PGg6zBM-nL.png?updatedAt=1766179731484'
  }
];

export const SERVICES: Service[] = [
  // Cleaning services
  {
    id: 'carpet-upholstery-cleaning',
    categoryId: 'cleaning',
    name: 'Carpet & upholstery cleaning',
    description: 'Professional cleaning & stain removal for carpets, rugs and upholstered seating',
    imageUrl: 'https://assets.codi.com/Services/Cleaning/Desktop/01%20Cleaning_WtVBJZQBkj.png',
    imageUrlMobile:
      'https://assets.codi.com/Services/Cleaning/Mobile/01%20Cleaning_xWCbJFiNB.png?updatedAt=1766186511198',
    initialMessage: "I'm interested in carpet and upholstery cleaning.",
    tags: [
      'carpet cleaning',
      'rug cleaning',
      'upholstery cleaning',
      'chair cleaning',
      'couch cleaning',
      'office furniture cleaning',
      'stain removal',
      'spot cleaning',
      'fabric cleaning',
      'deep carpet clean',
      'carpet',
      'upholstery',
      'rug',
      'furniture cleaning',
      'seating',
      'spill',
      'sofa',
      'dirt',
      'steam',
      'smell',
      'odor'
    ]
  },
  {
    id: 'conference-room-glass-cleaning',
    categoryId: 'cleaning',
    name: 'Conference room glass cleaning',
    description: 'Deep cleaning for glass partitions and windows in conference rooms',
    imageUrl: 'https://assets.codi.com/Services/Cleaning/Desktop/02%20Cleaning_g_MrVdyCv.png?updatedAt=1766186387902',
    imageUrlMobile:
      'https://assets.codi.com/Services/Cleaning/Mobile/02%20Cleaning_b_KQvclzl.png?updatedAt=1766186511102',
    initialMessage: "I'm interested in conference room glass cleaning.",
    tags: [
      'glass cleaning',
      'conference room glass',
      'meeting room glass',
      'glass partitions',
      'glass walls',
      'interior windows',
      'fingerprints on glass',
      'smudged glass',
      'office glass cleaning',
      'glass',
      'windows',
      'partitions',
      'conference room',
      'meeting room'
    ]
  },
  {
    id: 'deep-cleaning',
    categoryId: 'cleaning',
    name: 'Deep cleaning',
    description: 'Comprehensive deep cleaning service for your entire office space',
    imageUrl: 'https://assets.codi.com/Services/Cleaning/Desktop/03%20Cleaning_I7vfj2e6mE.png?updatedAt=1766186387941',
    imageUrlMobile:
      'https://assets.codi.com/Services/Cleaning/Mobile/03%20Cleaning_ajYl4Mojho.png?updatedAt=1766186511249',
    initialMessage: "I'm interested in deep cleaning services.",
    tags: [
      'deep cleaning',
      'office deep clean',
      'one-time cleaning',
      'post-event cleaning',
      'move-in cleaning',
      'move-out cleaning',
      'thorough cleaning',
      'full office clean',
      'sanitization',
      'deep clean',
      'comprehensive cleaning',
      'office cleaning',
      'dishwasher'
    ]
  },
  {
    id: 'waste-recycling-hauling',
    categoryId: 'cleaning',
    name: 'Waste & recycling hauling',
    description: 'Waste removal and recycling services for your office',
    imageUrl: 'https://assets.codi.com/Services/Cleaning/Desktop/04%20Cleaning_0JEpTDBi0.png?updatedAt=1766186387925',
    imageUrlMobile:
      'https://assets.codi.com/Services/Cleaning/Mobile/04%20Cleaning_c1458nzBx1.png?updatedAt=1766186511240',
    initialMessage: "I'm interested in waste and recycling hauling services.",
    tags: [
      'trash removal',
      'waste hauling',
      'recycling pickup',
      'junk removal',
      'office cleanout',
      'bulk trash',
      'garbage service',
      'recycling service',
      'haul away',
      'waste',
      'trash',
      'recycling',
      'garbage',
      'disposal',
      'hauling',
      'removal'
    ]
  },
  {
    id: 'window-cleaning',
    categoryId: 'cleaning',
    name: 'Window cleaning',
    description: 'Professional window cleaning services for interior and exterior windows',
    imageUrl: 'https://assets.codi.com/Services/Cleaning/Desktop/05%20Cleaning_89dERX6E-.png?updatedAt=1766186387939',
    imageUrlMobile:
      'https://assets.codi.com/Services/Cleaning/Mobile/05%20Cleaning_AJ3UcvxDd.png?updatedAt=1766186511224',
    initialMessage: "I'm interested in window cleaning services.",
    tags: [
      'window cleaning',
      'office windows',
      'interior window cleaning',
      'exterior window cleaning',
      'glass cleaning',
      'high windows',
      'streak-free windows',
      'building windows',
      'windows',
      'glass',
      'exterior',
      'interior'
    ]
  },
  // Design & experience services
  {
    id: 'care-room',
    categoryId: 'design',
    name: 'Care room',
    description: 'Create a private, comfortable space for employee lactation and personal care',
    imageUrl:
      'https://assets.codi.com/Services/DesignExperience/Desktop/00%20Design_rCZ2wXbtd.png?updatedAt=1766180679728',
    imageUrlMobile: 'https://assets.codi.com/Services/DesignExperience/Mobile/00%20Design_Rg2htLL8E.png',
    initialMessage: "I'm interested in a care room.",
    tags: [
      'lactation room',
      'nursing room',
      "mother's room",
      'wellness room',
      'care space',
      'private room',
      'employee wellness',
      'parent room',
      'quiet room',
      'lactation',
      'nursing',
      'private space'
    ]
  },
  {
    id: 'glass-frosting',
    categoryId: 'design',
    name: 'Glass frosting',
    description: 'Privacy film, applied to glass partitions, walls, and doors',
    imageUrl:
      'https://assets.codi.com/Services/DesignExperience/Desktop/01%20Design_hvcFJ8HOP.png?updatedAt=1766171414955',
    imageUrlMobile:
      'https://assets.codi.com/Services/DesignExperience/Mobile/01%20Design_cm_FsYIOT.png?updatedAt=1766171530114',
    initialMessage: "I'm interested in glass frosting services.",
    tags: [
      'frosted glass',
      'privacy film',
      'window film',
      'glass frosting',
      'conference room privacy',
      'office privacy',
      'etched glass look',
      'privacy decals',
      'privacy glass',
      'privacy'
    ]
  },
  {
    id: 'interior-design',
    categoryId: 'design',
    name: 'Interior design',
    description: 'Space planning, furniture & decor sourcing and ordering',
    imageUrl:
      'https://assets.codi.com/Services/DesignExperience/Desktop/02%20Design_sWHI1ET6x.png?updatedAt=1766171415157',
    imageUrlMobile:
      'https://assets.codi.com/Services/DesignExperience/Mobile/02%20Design_Z1-84jniF.png?updatedAt=1766171530526',
    initialMessage: "I'm interested in interior design services.",
    tags: [
      'office interior design',
      'space planning',
      'office layout',
      'furniture sourcing',
      'workspace design',
      'office decor',
      'office redesign',
      'floor plan',
      'furniture planning',
      'design',
      'furniture',
      'decor',
      'interior',
      'decoration'
    ]
  },
  {
    id: 'murals',
    categoryId: 'design',
    name: 'Murals',
    description: 'Artist-led mural design and painting services to match your brand',
    imageUrl:
      'https://assets.codi.com/Services/DesignExperience/Desktop/03%20Design_tMVL7pclx.png?updatedAt=1766171415164',
    imageUrlMobile:
      'https://assets.codi.com/Services/DesignExperience/Mobile/03%20Design_cepHbyEUN.png?updatedAt=1766171530345',
    initialMessage: "I'm interested in murals.",
    tags: [
      'office mural',
      'wall mural',
      'custom mural',
      'brand mural',
      'wall art',
      'office artwork',
      'feature wall',
      'artist mural',
      'mural',
      'art',
      'painting',
      'artist',
      'wall painting'
    ]
  },
  {
    id: 'painting',
    categoryId: 'design',
    name: 'Painting',
    description: 'Touch-ups or full repaints for accent walls',
    imageUrl:
      'https://assets.codi.com/Services/DesignExperience/Desktop/04%20Design_CQefzO5zg.png?updatedAt=1766171415109',
    imageUrlMobile:
      'https://assets.codi.com/Services/DesignExperience/Mobile/04%20Design_aCub7KbSt.png?updatedAt=1766171530313',
    initialMessage: "I'm interested in painting.",
    tags: [
      'office painting',
      'wall painting',
      'accent wall',
      'touch-up painting',
      'repaint office',
      'interior painting',
      'wall refresh',
      'paint',
      'touch-up',
      'repaint'
    ]
  },
  {
    id: 'plant-care',
    categoryId: 'design',
    name: 'Plant care',
    description: 'Assistance sourcing live plants and greenery programs for improved wellness and office aesthetics',
    imageUrl:
      'https://assets.codi.com/Services/DesignExperience/Desktop/05%20Design_-fAuyjuPo.png?updatedAt=1766171415118',
    imageUrlMobile:
      'https://assets.codi.com/Services/DesignExperience/Mobile/05%20Design_xSpVeMUxm.png?updatedAt=1766171530224',
    initialMessage: "I'm interested in plant care.",
    tags: [
      'office plants',
      'plant service',
      'plant maintenance',
      'office greenery',
      'biophilic design',
      'plant installation',
      'plant watering',
      'plant replacement',
      'plants',
      'greenery',
      'wellness',
      'indoor plants'
    ]
  },
  {
    id: 'signage',
    categoryId: 'design',
    name: 'Signage',
    description: 'Custom logos, office wayfinding signage, conference room labels, and compliance signs',
    imageUrl:
      'https://assets.codi.com/Services/DesignExperience/Desktop/06%20Design_GGoJLXguF.png?updatedAt=1766171415175',
    imageUrlMobile:
      'https://assets.codi.com/Services/DesignExperience/Mobile/06%20Design_H-si5drOe.png?updatedAt=1766171530583',
    initialMessage: "I'm interested in signage.",
    tags: [
      'office signage',
      'wayfinding',
      'door signs',
      'conference room signs',
      'logo signage',
      'wall signage',
      'ADA signage',
      'office labels',
      'signs',
      'logos',
      'labels',
      'compliance',
      'room labels'
    ]
  },
  // IT & A/V support services
  {
    id: 'cable-management',
    categoryId: 'it',
    name: 'Cable management',
    description: 'Deliver reliable power to all desks and tables, keeping cables neatly managed and out of the way',
    imageUrl: 'https://assets.codi.com/Services/ItAvSupport/Desktop/01%20IT_WSdV96j-V.png?updatedAt=1766172960071',
    imageUrlMobile: 'https://assets.codi.com/Services/ItAvSupport/Mobile/01%20IT_lyxWsYKDJ.png',
    initialMessage: "I'm interested in cable management.",
    tags: [
      'cable management',
      'desk cable cleanup',
      'wire management',
      'power cables',
      'under-desk cables',
      'cord organization',
      'desk setup',
      'cables',
      'power',
      'desk',
      'table',
      'cable organization'
    ]
  },
  {
    id: 'conference-room-av',
    categoryId: 'it',
    name: 'Conference room A/V',
    description: 'Schedule a conference room assessment for expert sound system recommendations and installation',
    imageUrl: 'https://assets.codi.com/Services/ItAvSupport/Desktop/02%20IT_uor8XCqQ9.png?updatedAt=1766172959541',
    imageUrlMobile: 'https://assets.codi.com/Services/ItAvSupport/Mobile/02%20IT_SY5lTVp1Z.png?updatedAt=1766175520275',
    initialMessage: "I'm interested in conference room A/V.",
    tags: [
      'conference room AV',
      'video conferencing',
      'meeting room setup',
      'TV installation',
      'microphones',
      'speakers',
      'Zoom room',
      'AV install',
      'AV',
      'audio visual',
      'sound system',
      'conference room',
      'meeting room',
      'audiovisual'
    ]
  },
  {
    id: 'room-booking-systems',
    categoryId: 'it',
    name: 'Room-booking systems',
    description:
      'Install and manage room-booking tools that sync with calendars so teams can easily reserve meeting rooms',
    imageUrl: 'https://assets.codi.com/Services/ItAvSupport/Desktop/03%20IT_dZML7pcnm.png?updatedAt=1766172959990',
    imageUrlMobile: 'https://assets.codi.com/Services/ItAvSupport/Mobile/03%20IT_z7yAxZDyT.png?updatedAt=1766175520274',
    initialMessage: "I'm interested in room-booking systems.",
    tags: [
      'room booking',
      'conference room scheduling',
      'meeting room display',
      'room panels',
      'calendar display',
      'workspace scheduling',
      'room reservation system',
      'booking',
      'scheduling',
      'calendar',
      'reservation'
    ]
  },
  {
    id: 'network-installation',
    categoryId: 'it',
    name: 'Network installation',
    description: 'Cabling, router and access point installation, network optimization, and more',
    imageUrl: 'https://assets.codi.com/Services/ItAvSupport/Desktop/04%20IT_pGtnf_1sf.png?updatedAt=1766172960113',
    imageUrlMobile: 'https://assets.codi.com/Services/ItAvSupport/Mobile/03%20IT_8bdZIDrzg.png?updatedAt=1766172790939',
    initialMessage: "I'm interested in network installation.",
    tags: [
      'network installation',
      'office wifi setup',
      'ethernet cabling',
      'router installation',
      'access points',
      'internet setup',
      'IT install',
      'network',
      'cabling',
      'router',
      'WiFi',
      'access point',
      'internet',
      'wireless'
    ]
  },
  {
    id: 'network-management',
    categoryId: 'it',
    name: 'Network management',
    description: 'Assign and update WiFi networks and passwords, plus troubleshoot existing equipment',
    imageUrl: 'https://assets.codi.com/Services/ItAvSupport/Desktop/05%20IT_gbxJEj9toe.png?updatedAt=1766172960138',
    imageUrlMobile: 'https://assets.codi.com/Services/ItAvSupport/Mobile/04%20IT_9Iaiml69y.png?updatedAt=1766172790963',
    initialMessage: "I'm interested in network management.",
    tags: [
      'network support',
      'wifi management',
      'internet troubleshooting',
      'password updates',
      'network maintenance',
      'IT support',
      'office wifi issues',
      'WiFi',
      'network',
      'password',
      'troubleshooting',
      'wireless',
      'internet'
    ]
  },
  {
    id: 'printing',
    categoryId: 'it',
    name: 'Printing',
    description: 'Rent or purchase equipment and order supplies',
    imageUrl: 'https://assets.codi.com/Services/ItAvSupport/Desktop/06%20IT_MBRJ2mxu5J.png?updatedAt=1766172960104',
    imageUrlMobile: 'https://assets.codi.com/Services/ItAvSupport/Mobile/05%20IT_VYy2BQ4bA.png',
    initialMessage: "I'm interested in printing services.",
    tags: [
      'office printer',
      'printer rental',
      'printer purchase',
      'copier',
      'printer supplies',
      'toner',
      'managed print services',
      'printer',
      'print',
      'equipment',
      'supplies'
    ]
  },
  // Maintenance services
  {
    id: 'electrical-services',
    categoryId: 'maintenance',
    name: 'Electrical services',
    description: 'Repair and replace lights, install outlets, and more',
    imageUrl:
      'https://assets.codi.com/Services/Maintenance/Desktop/02%20maintenance_Kb9IPPx6D.png?updatedAt=1766173589824',
    imageUrlMobile:
      'https://assets.codi.com/Services/Maintenance/Mobile/02%20Maintenance_SYBJjcwy7.png?updatedAt=1766173600926',
    initialMessage: "I'm interested in electrical services.",
    tags: [
      'electrician',
      'office electrical',
      'outlet installation',
      'light repair',
      'lighting install',
      'power issues',
      'electrical repair',
      'electrical',
      'lights',
      'outlets',
      'repair'
    ]
  },
  {
    id: 'furniture-assembly-repairs',
    categoryId: 'maintenance',
    name: 'Furniture assembly & repairs',
    description: 'Schedule expert assembly and repair for your office furniture',
    imageUrl:
      'https://assets.codi.com/Services/Maintenance/Desktop/01%20maintenance_TN5WjpzEh.png?updatedAt=1766173589312',
    imageUrlMobile:
      'https://assets.codi.com/Services/Maintenance/Mobile/01%20Maintenance_qsg4YRQX8.png?updatedAt=1766173600465',
    initialMessage: "I'm interested in furniture assembly & repairs.",
    tags: [
      'furniture assembly',
      'desk assembly',
      'office furniture repair',
      'chair repair',
      'reassemble furniture',
      'handyman furniture',
      'furniture',
      'assembly',
      'repair',
      'office furniture',
      'desk',
      'chair'
    ]
  },
  {
    id: 'hvac',
    categoryId: 'maintenance',
    name: 'HVAC',
    description: 'Repair and maintain heating and cooling systems to keep your office comfortable and running smoothly',
    imageUrl:
      'https://assets.codi.com/Services/Maintenance/Desktop/03%20maintenance_7u_IVLt0ej.png?updatedAt=1766173590229',
    imageUrlMobile:
      'https://assets.codi.com/Services/Maintenance/Mobile/03%20Maintenance_VvMejgj7n.png?updatedAt=1766173600740',
    initialMessage: "I'm interested in HVAC services.",
    tags: [
      'HVAC',
      'heating and cooling',
      'AC repair',
      'office temperature issues',
      'air conditioning',
      'ventilation',
      'thermostat',
      'heating',
      'cooling',
      'AC',
      'climate control'
    ]
  },
  {
    id: 'layout-change',
    categoryId: 'maintenance',
    name: 'Layout change',
    description: 'Adjust and optimize your office layout as your needs change',
    imageUrl:
      'https://assets.codi.com/Services/Maintenance/Desktop/05%20maintenance_Also1HVf6.png?updatedAt=1766173590223',
    imageUrlMobile:
      'https://assets.codi.com/Services/Maintenance/Mobile/05%20Maintenance_eczEqt8eaA.png?updatedAt=1766173600933',
    initialMessage: "I'm interested in layout change services.",
    tags: [
      'office reconfiguration',
      'layout change',
      'desk moves',
      'rearrange office',
      'workspace changes',
      'office setup',
      'restack',
      'layout',
      'office layout',
      'reorganization',
      'space planning',
      'rearrange'
    ]
  },
  {
    id: 'moving',
    categoryId: 'maintenance',
    name: 'Moving',
    description: 'Moving help for single heavy items up to full office transitions',
    imageUrl:
      'https://assets.codi.com/Services/Maintenance/Desktop/06%20maintenance_3KJ2SDMl8.png?updatedAt=1766173590160',
    imageUrlMobile:
      'https://assets.codi.com/Services/Maintenance/Mobile/06%20Maintenance_OClaoo3cR8.png?updatedAt=1766173600937',
    initialMessage: "I'm interested in moving services.",
    tags: [
      'office move',
      'internal move',
      'furniture moving',
      'heavy lifting',
      'office relocation',
      'move desks',
      'office equipment',
      'move',
      'relocation',
      'heavy items',
      'moving help'
    ]
  },
  {
    id: 'mounting',
    categoryId: 'maintenance',
    name: 'Mounting',
    description: 'Get help installing whiteboards, TVs, signage, and other small fixtures',
    imageUrl:
      'https://assets.codi.com/Services/Maintenance/Desktop/07%20maintenance_E0gP7Mx2CC.png?updatedAt=1766173590218',
    imageUrlMobile:
      'https://assets.codi.com/Services/Maintenance/Mobile/07%20Maintenance_Pb4kwIVC0.png?updatedAt=1766173600741',
    initialMessage: "I'm interested in mounting services.",
    tags: [
      'TV mounting',
      'whiteboard install',
      'wall mounting',
      'monitor mounting',
      'sign installation',
      'fixture install',
      'mount',
      'install',
      'whiteboard',
      'TV',
      'signage',
      'fixtures',
      'wall mount'
    ]
  },
  {
    id: 'pest-control',
    categoryId: 'maintenance',
    name: 'Pest control',
    description:
      'Identify and treat common office pests with preventative and responsive services to keep your workplace clean and safe',
    imageUrl:
      'https://assets.codi.com/Services/Maintenance/Desktop/09%20maintenance_s5xPLkEWmo.png?updatedAt=1766173590279',
    imageUrlMobile:
      'https://assets.codi.com/Services/Maintenance/Mobile/09%20Maintenance_ahr6wW6xAg.png?updatedAt=1766173600979',
    initialMessage: "I'm interested in pest control services.",
    tags: [
      'pest control',
      'exterminator',
      'rodent control',
      'ants',
      'cockroaches',
      'office pests',
      'bug problem',
      'pest',
      'bugs',
      'rodents',
      'extermination'
    ]
  },
  {
    id: 'plumbing-services',
    categoryId: 'maintenance',
    name: 'Plumbing services',
    description: 'Resolve clogs, leaks, burst pipes, replacements, and more',
    imageUrl:
      'https://assets.codi.com/Services/Maintenance/Desktop/04%20maintenance_4Qxs_g6Yfw.png?updatedAt=1766173590273',
    imageUrlMobile:
      'https://assets.codi.com/Services/Maintenance/Mobile/04%20Maintenance_e4TQA_Jv-A.png?updatedAt=1766173600867',
    initialMessage: "I'm interested in plumbing services.",
    tags: [
      'plumber',
      'office plumbing',
      'clogged sink',
      'leak repair',
      'toilet repair',
      'burst pipe',
      'water issues',
      'plumbing',
      'clog',
      'leak',
      'pipes',
      'water',
      'dishwasher'
    ]
  },
  // Pantry, beverages, & catering services
  {
    id: 'ad-hoc-catering',
    categoryId: 'catering-events',
    name: 'Ad-hoc catering',
    description: 'Order one-time catering for planned gatherings of any size, from all-hands to meetings and events',
    imageUrl:
      'https://assets.codi.com/Services/PantryBeveragesCatering/Desktop/05%20Pantry_kjxwVhQlLv.png?updatedAt=1766176219216',
    imageUrlMobile:
      'https://assets.codi.com/Services/PantryBeveragesCatering/Mobile/05%20Pantry_vnOtx5sxJ4.png?updatedAt=1766176376216',
    initialMessage: "I'm interested in ad-hoc catering.",
    tags: [
      'office catering',
      'event catering',
      'meeting food',
      'all-hands catering',
      'lunch catering',
      'one-time catering',
      'catering',
      'food',
      'events',
      'meetings',
      'all-hands',
      'gatherings'
    ]
  },
  {
    id: 'coffee-service',
    categoryId: 'catering-events',
    name: 'Coffee service',
    description:
      'Enjoy a fully-serviced coffee station with everything from equipment rentals to maintenance and supply restocks',
    imageUrl:
      'https://assets.codi.com/Services/PantryBeveragesCatering/Desktop/01%20Pantry_uRfT06Cyc.png?updatedAt=1766176218550',
    imageUrlMobile:
      'https://assets.codi.com/Services/PantryBeveragesCatering/Mobile/01%20Pantry_bzW47-_QU.png?updatedAt=1766176231559',
    initialMessage: "I'm interested in coffee service.",
    tags: [
      'office coffee',
      'coffee service',
      'espresso machine',
      'coffee machine rental',
      'coffee supplies',
      'barista setup',
      'coffee',
      'espresso',
      'caffeine',
      'coffee station',
      'beverages'
    ]
  },
  {
    id: 'happy-hour',
    categoryId: 'catering-events',
    name: 'Happy hour',
    description: 'Have food, drinks, and alcohol delivered and ready for your team or event',
    imageUrl:
      'https://assets.codi.com/Services/PantryBeveragesCatering/Desktop/04%20Pantry_t5o-7nZglq.png?updatedAt=1766176218811',
    imageUrlMobile:
      'https://assets.codi.com/Services/PantryBeveragesCatering/Mobile/04%20Pantry_lCPL_8BE1.png?updatedAt=1766176376088',
    initialMessage: "I'm interested in happy hour.",
    tags: [
      'office happy hour',
      'team drinks',
      'office alcohol',
      'event drinks',
      'cocktail catering',
      'beer and wine',
      'happy hour',
      'drinks',
      'alcohol',
      'food',
      'beverages',
      'events'
    ]
  },
  {
    id: 'pantry-inventory-tracking-auto-ordering',
    categoryId: 'catering-events',
    name: 'Pantry inventory tracking & auto-ordering',
    description: 'Stay stocked effortlessly with supply tracking that orders automatically',
    imageUrl:
      'https://assets.codi.com/Services/PantryBeveragesCatering/Desktop/03%20Pantry_UKUJ0YSeE.png?updatedAt=1766176219104',
    imageUrlMobile:
      'https://assets.codi.com/Services/PantryBeveragesCatering/Mobile/03%20Pantry_e83g2_Kd8.png?updatedAt=1766176376089',
    initialMessage: "I'm interested in pantry inventory tracking & auto-ordering.",
    tags: [
      'pantry management',
      'snack restocking',
      'office snacks',
      'inventory tracking',
      'auto reorder',
      'pantry service',
      'pantry',
      'inventory',
      'auto-ordering',
      'supplies',
      'restocking',
      'tracking'
    ]
  },
  {
    id: 'recurring-breakfast',
    categoryId: 'catering-events',
    name: 'Recurring breakfast',
    description: 'Get breakfast catering delivered 1-5 days per week for mornings in the office',
    imageUrl:
      'https://assets.codi.com/Services/PantryBeveragesCatering/Desktop/08%20Pantry_ADxA96R0Mf.png?updatedAt=1766176219115',
    imageUrlMobile:
      'https://assets.codi.com/Services/PantryBeveragesCatering/Mobile/08%20Pantry_Mp6fhz4jbx.png?updatedAt=1766176376190',
    initialMessage: "I'm interested in recurring breakfast.",
    tags: [
      'office breakfast',
      'recurring breakfast',
      'daily breakfast',
      'morning catering',
      'breakfast delivery',
      'breakfast',
      'morning',
      'food',
      'catering',
      'recurring'
    ]
  },
  {
    id: 'recurring-individual-meals',
    categoryId: 'catering-events',
    name: 'Recurring individual meals',
    description: 'Let teammates choose their own meals on a recurring cadence',
    imageUrl:
      'https://assets.codi.com/Services/PantryBeveragesCatering/Desktop/06%20Pantry_avUrPmP4Ew.png?updatedAt=1766176219071',
    imageUrlMobile:
      'https://assets.codi.com/Services/PantryBeveragesCatering/Mobile/06%20Pantry_SZIFEbASP6.png?updatedAt=1766176376179',
    initialMessage: "I'm interested in recurring individual meals.",
    tags: [
      'meal stipend',
      'individual meals',
      'employee meals',
      'recurring meals',
      'lunch credits',
      'meal program',
      'meals',
      'individual',
      'food',
      'lunch',
      'dinner',
      'recurring'
    ]
  },
  {
    id: 'recurring-team-lunch',
    categoryId: 'catering-events',
    name: 'Recurring team lunch',
    description: 'Provide recurring team lunches with convenient buffet-style service',
    imageUrl:
      'https://assets.codi.com/Services/PantryBeveragesCatering/Desktop/07%20Pantry_4orqW8k_L.png?updatedAt=1766176219150',
    imageUrlMobile:
      'https://assets.codi.com/Services/PantryBeveragesCatering/Mobile/07%20Pantry_rwiUwOphXi.png?updatedAt=1766176376213',
    initialMessage: "I'm interested in recurring team lunch.",
    tags: [
      'team lunch',
      'recurring lunch',
      'office lunch',
      'buffet lunch',
      'weekly lunch',
      'company lunch',
      'lunch',
      'buffet',
      'food',
      'catering',
      'recurring'
    ]
  },
  {
    id: 'water-service',
    categoryId: 'catering-events',
    name: 'Water service',
    description:
      'Set up recurring bottled or plumbed water service, complete with equipment, maintenance, and delivery',
    imageUrl:
      'https://assets.codi.com/Services/PantryBeveragesCatering/Desktop/02%20Pantry_M4pVw0L-z.png?updatedAt=1766176217572',
    imageUrlMobile:
      'https://assets.codi.com/Services/PantryBeveragesCatering/Mobile/02%20Pantry_1m9nho1OT.png?updatedAt=1766176375701',
    initialMessage: "I'm interested in water service.",
    tags: [
      'office water',
      'water delivery',
      'water cooler',
      'filtered water',
      'bottled water',
      'hydration station',
      'water',
      'plumbed water',
      'hydration',
      'beverages'
    ]
  },
  // Security & access services
  {
    id: 'alarm-systems',
    categoryId: 'security-access',
    name: 'Alarm systems',
    description: 'Install and manage alarm systems to help protect your office from unauthorized access',
    imageUrl:
      'https://assets.codi.com/Services/SecurityAccess/Desktop/01%20SecurityAccess_EehWWtEav.png?updatedAt=1766179604759',
    imageUrlMobile:
      'https://assets.codi.com/Services/SecurityAccess/Mobile/01%20SecurityAccess_Hn2HqcfA0.png?updatedAt=1766179731268',
    initialMessage: "I'm interested in alarm systems.",
    tags: [
      'office alarm',
      'security alarm',
      'intrusion alarm',
      'alarm monitoring',
      'security system',
      'alarm',
      'security',
      'monitoring',
      'alert'
    ]
  },
  {
    id: 'cameras-doorbells',
    categoryId: 'security-access',
    name: 'Cameras & doorbells',
    description: 'Install and manage security cameras, video doorbells, and intercom systems',
    imageUrl:
      'https://assets.codi.com/Services/SecurityAccess/Desktop/02%20SecurityAccess_XtKfe3Gox.png?updatedAt=1766179604960',
    imageUrlMobile:
      'https://assets.codi.com/Services/SecurityAccess/Mobile/02%20SecurityAccess_cTMCMkTpO_.png?updatedAt=1766179731456',
    initialMessage: "I'm interested in cameras & doorbells.",
    tags: [
      'security cameras',
      'video surveillance',
      'doorbell camera',
      'intercom',
      'office cameras',
      'entry monitoring',
      'cameras',
      'doorbells',
      'video',
      'intercom',
      'surveillance'
    ]
  },
  {
    id: 'insurance',
    categoryId: 'security-access',
    name: 'Insurance',
    description: 'Liability coverage for your business',
    imageUrl:
      'https://assets.codi.com/Services/SecurityAccess/Desktop/03%20SecurityAccess_zUPWA_wEm.png?updatedAt=1766179604820',
    imageUrlMobile:
      'https://assets.codi.com/Services/SecurityAccess/Mobile/03%20SecurityAccess_mI0Flw9W0.png?updatedAt=1766179822279',
    initialMessage: "I'm interested in learning about insurance.",
    tags: [
      'business insurance',
      'office insurance',
      'liability insurance',
      'general liability',
      'coverage',
      'policy',
      'insurance',
      'liability'
    ]
  },
  {
    id: 'keyless-digital-access-solutions',
    categoryId: 'security-access',
    name: 'Keyless & digital access solutions',
    description:
      'Manage access with a cloud-based system featuring digital credentials, centralized control, and real-time logs',
    imageUrl:
      'https://assets.codi.com/Services/SecurityAccess/Desktop/04%20SecurityAccess_-IdWM-h-Mx.png?updatedAt=1766179604900',
    imageUrlMobile:
      'https://assets.codi.com/Services/SecurityAccess/Mobile/04%20SecurityAccess_PlO3K7l9US.png?updatedAt=1766179731392',
    initialMessage: "I'm interested in keyless & digital access solutions.",
    tags: [
      'keyless access',
      'digital access',
      'access control',
      'badge access',
      'mobile credentials',
      'door access system',
      'keyless',
      'credentials',
      'smart lock',
      'keycard'
    ]
  },
  {
    id: 'keypads',
    categoryId: 'security-access',
    name: 'Keypads',
    description: 'Install a smart lock on your interior suite door for secure PIN code access',
    imageUrl:
      'https://assets.codi.com/Services/SecurityAccess/Desktop/05%20SecurityAccess_KR_030Kozy.png?updatedAt=1766179604950',
    imageUrlMobile:
      'https://assets.codi.com/Services/SecurityAccess/Mobile/05%20SecurityAccess_iPwqNc3Wp.png?updatedAt=1766179731419',
    initialMessage: "I'm interested in keypads.",
    tags: [
      'door keypad',
      'PIN access',
      'smart lock',
      'keypad lock',
      'code entry',
      'office lock',
      'keypad',
      'PIN',
      'code',
      'door lock',
      'access'
    ]
  },
  {
    id: 'lockboxes',
    categoryId: 'security-access',
    name: 'Lockboxes',
    description: 'Install lockboxes with permanent & temporary codes to store physical keys onsite',
    imageUrl:
      'https://assets.codi.com/Services/SecurityAccess/Desktop/06%20SecurityAccess_hTT2vQxYo.png?updatedAt=1766179606137',
    imageUrlMobile:
      'https://assets.codi.com/Services/SecurityAccess/Mobile/06%20SecurityAccess_fdSrYSJv1.png?updatedAt=1766179822086',
    initialMessage: "I'm interested in lockboxes.",
    tags: [
      'lockbox',
      'key storage',
      'key lockbox',
      'temporary access',
      'contractor access',
      'physical keys',
      'keys',
      'code'
    ]
  },
  {
    id: 'visitor-management',
    categoryId: 'security-access',
    name: 'Visitor management',
    description:
      'Set up visitor check-in tools to track guests notify hosts and support a secure front desk experience',
    imageUrl:
      'https://assets.codi.com/Services/SecurityAccess/Desktop/07%20SecurityAccess_Fr6dHUho-.png?updatedAt=1767736268000',
    imageUrlMobile:
      'https://assets.codi.com/Services/SecurityAccess/Mobile/07%20SecurityAccess_rH-xDVr-GN.png?updatedAt=1766179731451',
    initialMessage: "I'm interested in visitor management.",
    tags: [
      'visitor management',
      'guest check-in',
      'front desk software',
      'visitor logs',
      'office check-in',
      'reception system',
      'visitor',
      'guests',
      'check-in',
      'reception'
    ]
  }
];

// Message for generic custom service requests (matches SupportRequestIntent)
export const CUSTOM_SERVICE_REQUEST_MESSAGE = "I need a service that isn't listed.";
